import { getTurboResponse, waitMs } from "../../utils";
import * as lo from "lodash";

export const AssignScore = {
  ManuallyUnassigned: "ManuallyUnassigned",
  ManuallyAssigned: "ManuallyAssigned",
  DetectedUnassigned: "DetectedUnassigned",
  DetectedAssigned: "DetectedAssigned",

  isUnassigned: (assignScore) =>
    assignScore === AssignScore.DetectedUnassigned ||
    assignScore === AssignScore.ManuallyUnassigned,
  isDetectedUnassigned: (assignScore) =>
    assignScore === AssignScore.DetectedUnassigned,
  isAssigned: (score) =>
    score === AssignScore.ManuallyAssigned ||
    score === AssignScore.DetectedAssigned,
};
/**
 *  We inject a `terminal` prop on window with
 *  {
 *      socket: WebSocket // long-lived WS connection to term_ctrl
 *      state: { active: bool } // initialized to: TerminalInitialState
 *      data: { id: int, token: string } // Auth received from Terminal WS
 *  }
 *  Data is injected on any request in the header as `Authorization: Terminal {id} {token}`
 */

export const TerminalInitialState = {
  active: true,
};

export function addTerminalAuthorizationOnTurboFetch() {
  document.addEventListener("turbo:before-fetch-request", (event) => {
    event.preventDefault();
    event.detail.fetchOptions.headers["Authorization"] = getAuthHeaderValue();
    event.detail.resume();
  });
}

function getAuthHeaderValue() {
  const terminalData = window.terminal.data;
  if (!terminalData)
    throw new Error("FLOW ERROR - accessed uninitialized terminal data.");
  return ["Terminal", terminalData.id, terminalData.token].join(" ");
}

export function verifySocketWatchdog() {
  if (window.terminal.socket === undefined) {
    console.error("Socket undefined. Reloading;");
    return goToInit();
  }
  if (window.terminal.socket.readyState !== WebSocket.OPEN) {
    console.error("Socket not opened. Reloading;");
    return goToInit();
  }
}

export function goToInit() {
  window.location = "/ui/terminal/";
}

export async function terminalRequest(url, config) {
  const formData = config.formData ?? {};
  const init = lo.omit(config, ["formData"]);
  init.headers = {
    ...(config.headers ?? {}),
    Authorization: getAuthHeaderValue(),
  };
  return getTurboResponse(url, formData ?? {}, init);
}

export async function getGlobalHealthySocket() {
  if (
    !window.terminal ||
    !window.terminal.socket ||
    window.terminal.socket.readyState !== WebSocket.OPEN
  ) {
    await waitMs(1);
    return getGlobalHealthySocket();
  }
  return window.terminal.socket;
}
